// src/components/common/ActionsDrawer.js
import React from 'react';
import { X, Loader2 } from 'lucide-react';

/**
 * Painel de ações deslizando da lateral direita — substitui os ícones soltos
 * na coluna "Ações" das tabelas de listagem. Espelha o ActionDrawer do
 * /mobile (mobile/components/ui/action-drawer.tsx): título/subtítulo do item
 * selecionado no cabeçalho, lista vertical de ações com ícone + rótulo.
 *
 * actions: [{ key, label, icon, onClick, disabled, loading, destructive, success }]
 * Cada onClick é responsável por fechar o drawer quando fizer sentido (ex.:
 * "Excluir" pode manter aberto até confirmar) — o componente não fecha sozinho.
 */
const ActionsDrawer = ({ open, onClose, title, subtitle, icon, actions = [] }) => {
    if (!open) return null;

    return (
        <div className="side-drawer-overlay" onClick={onClose}>
            <div className="side-drawer-panel" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <div className="modal-header__main-info">
                        <h4 className="modal-title">
                            {icon}
                            {title}
                        </h4>
                        {subtitle && <p className="modal-subtitle">{subtitle}</p>}
                    </div>
                    <button className="modal-close-button" onClick={onClose} aria-label="Fechar">
                        <X size={20} />
                    </button>
                </div>

                <div className="side-drawer-body">
                    <ul className="modal-actions-list">
                        {actions.map((a) => (
                            <li key={a.key}>
                                <button
                                    className={`modal-action-button ${a.destructive ? 'is-destructive' : ''} ${a.success ? 'is-success' : ''}`}
                                    onClick={a.onClick}
                                    disabled={a.disabled || a.loading}
                                >
                                    {a.loading ? <Loader2 className="icon animate-spin" size={20} /> : a.icon}
                                    {a.label}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default ActionsDrawer;
